import React from "react";

/**
 * Motorcycle / scooter full-face helmet icon.
 * Matches lucide-react API: `size`, `className`, `strokeWidth`, `color`.
 */
export const ScooterHelmet = ({
  size = 24,
  className = "",
  strokeWidth = 2,
  color = "currentColor",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Outer shell — dome shape sitting on chin bar */}
    <path d="M3.5 14a8.5 8.5 0 0 1 17 0v3.2a1.8 1.8 0 0 1-1.8 1.8H5.3A1.8 1.8 0 0 1 3.5 17.2Z" />
    {/* Visor — curved rectangle */}
    <path d="M6.5 11.5c1.4-1.5 3.2-2.3 5.5-2.3s4.1.8 5.5 2.3v2.2c0 .6-.5 1.1-1.1 1.1H7.6c-.6 0-1.1-.5-1.1-1.1Z" />
    {/* Chin strap */}
    <path d="M8 19v1.2c0 .4.4.8.9.8h6.2c.5 0 .9-.4.9-.8V19" />
  </svg>
);

export default ScooterHelmet;
